import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initializePWA, checkRemoteAppVersion, clearAllCaches } from './utils/pwaUtils';

// Check remote app version and clear cache/reload if changed
checkRemoteAppVersion();

// Initialize PWA utilities to prevent white screen issues
initializePWA();

// Register service worker for PWA functionality (only in production)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration);
      })
      .catch((registrationError) => {
        console.error('SW registration failed:', registrationError);
        // Clear caches and try again on registration failure
        clearAllCaches();
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
